import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';

import { ToasterService } from '../../../_services/toaster.service';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenicationService} from '../../../_services/authenication.service';
import { PsychometrictestService } from '../../../_services/psychometrictest.service';

import {first} from 'rxjs/operators';

@Component({
  selector: 'app-add-test',
  templateUrl: './add-test.component.html',
  styleUrls: ['./add-test.component.css']
})
export class AddTestComponent implements OnInit {

  addTestForm: FormGroup;
  submitted = false;
  returnUrl: string;
  userdetaild: string;
  categories: [];
  items: FormArray;
  msgcode: string;


  constructor(private formBuilder: FormBuilder, private router: Router, private route: ActivatedRoute, private toaster: ToasterService, private authenicationService: AuthenicationService, private psychometrictestservice: PsychometrictestService) { }

  ngOnInit() {
    this.userdetaild = this.authenicationService.userDetails();
    if (!this.userdetaild) {
      this.router.navigate(['/login']);
    }
    if (!this.userdetaild || this.userdetaild['users_usertype'] == 'employee2') {
      this.router.navigate(['/']);
    }

    this.addTestForm = this.formBuilder.group({
      cat_id: ['', [Validators.required]],
      test_question: ['', [Validators.required]],
      test_question_status: ['true', [Validators.required]],
      test_sub_question: ['N/A'],
      items: this.formBuilder.array([ this.createItem() ])
    });


    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';

    this.categoriesList();
  }

  categoriesList() {
    this.psychometrictestservice.getAllCategories()
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            // this.toaster.showSuccess('Add Doctor', data.ResponseMessage);
            this.categories = data.testCategoriesList;
          } else {
            this.toaster.showError('Categories', data.ResponseMessage);
          }
          // this.router.navigate([this.returnUrl]);
        },
        error => {
          this.toaster.showError('Categories', error.error.ResponseMessage);
        });
  }

  get f() { return this.addTestForm.controls; }

  createItem(): FormGroup {
    return this.formBuilder.group({
      option: ['', [Validators.required]],
      point: ['', [Validators.required]]
    });
  }

  getValidity(i) {
    return (<FormArray>this.addTestForm.get('features')).controls[i].invalid;
  }


  addItem(): void {
    this.items = this.addTestForm.get('items') as FormArray;
    this.items.push(this.createItem());
  }
  removeItem(index): void{
    this.items.removeAt(index);
  }

  onSubmit(){

    this.submitted = true;
    // stop here if form is invalid
    if (this.addTestForm.invalid) {
      return;
    }

    const addquestion = {
      cat_id: this.addTestForm.controls.cat_id.value,
      test_question: this.addTestForm.controls.test_question.value,
      test_sub_question: this.addTestForm.controls.test_sub_question.value,
    };
    this.addTestQuestion(addquestion);
  }



  addTestQuestion(payload) {
    this.psychometrictestservice.addTestQuestion(payload)
      .pipe(first())
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {

            const addquestionanswer = {
              question_id: data.QuestionData._id,
              answer_options: this.addTestForm.controls.items.value
            };


            this.addTestAnswers(addquestionanswer);

          } else {
            this.toaster.showError('Add Test', data.ResponseMessage);
            this.msgcode = data.ResponseCode;
          }
          // this.router.navigate([this.returnUrl]);
        },
        error => {
          this.toaster.showError('Add Test', error.error.ResponseMessage);
          this.msgcode = error.error.ResponseCode;
        });
  }


  addTestAnswers(payload) {
    this.psychometrictestservice.addTestAnswers(payload)
      .pipe(first())
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            //this.toaster.showSuccess('Add Test', data.ResponseMessage);
            this.router.navigate(['/testlist']);
          } else {
            this.toaster.showError('Add Test', data.ResponseMessage);
          }
          // this.router.navigate([this.returnUrl]);
        },
        error => {
          this.toaster.showError('Add Test', error.error.ResponseMessage);
        });
  }

}
